// extracted by mini-css-extract-plugin
module.exports = {"starting":"StartingPageContent_starting__kwCvL"};